import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateNotificationRuleMutation } from '@axilon-apps/domains-ontology-ui-state'

import { NotificationRuleForm } from '../../../components/notification-rules/NotificationRuleForm'
import { DetailHeader } from '../../ConfigurePage/components/DetailHeader'

const NotificationRuleNewPage = () => {
  const navigate = useNavigate()
  const [createRule, { isLoading, error }] = useCreateNotificationRuleMutation()
  const [formError, setFormError] = useState<string | null>(null)

  const goBack = () => void navigate('/configure?type=notification-rules')

  return (
    <div className="mx-auto flex max-w-190 flex-col gap-6">
      <DetailHeader
        title="Create notification rule"
        backLabel="Notification rules"
        onBack={goBack}
      />

      <NotificationRuleForm
        busy={isLoading}
        error={formError ?? (error ? String(error) : null)}
        submitLabel="Create rule"
        onCancel={goBack}
        onSubmit={async (payload) => {
          try {
            setFormError(null)
            const created = await createRule(payload).unwrap()
            void navigate(
              `/configure?type=notification-rules&id=${encodeURIComponent(created.id)}`,
              { replace: true }
            )
          } catch (e) {
            setFormError(String(e))
            throw e
          }
        }}
      />
    </div>
  )
}

export default NotificationRuleNewPage
